import { render, staticRenderFns } from "./TollfreePorting.vue?vue&type=template&id=2af5df6e"
import script from "./TollfreePorting.vue?vue&type=script&lang=js"
export * from "./TollfreePorting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports